'use client'

import React from 'react'
import { NavGroup } from '@payloadcms/ui'

export const SeedManagementNavLink: React.FC = () => {
  return (
    <NavGroup label="Tools">
      <a className="nav__link" id="nav-seed-management" href="/admin/seed-management">
        <span className="nav__link-label">Seed Management</span>
      </a>
    </NavGroup>
  )
}

export default SeedManagementNavLink
